export function renderReaderSkeleton() {
	return `
<div class="app-menu-toggle" data-action="toggle-menu" data-action-value="show">≡</div>
<div id="app-menu" class="app-menu"></div>
<div id="article-view" class="article-view">Loading edition …</div>
<div id="overview" class="overview"></div>
<div id="toc" class="toc-list"></div>
<div id="help" class="help">
	<button type="button" data-action="set-design"><kbd>n</kbd> Toggle design </button>
	<button type="button" data-action="set-mode"><kbd>f</kbd> Toggle text flow</button>
	<button type="button" data-action="set-font"><kbd>v</kbd> Toggle font</button>
	<button type="button" data-action="next-card"><kbd>→</kbd> Next page</button>
	<button type="button" data-action="previous-card"><kbd>←</kbd> Previous page</button>
	<button type="button" data-action="next-article"><kbd>↓</kbd> Next article</button>
	<button type="button" data-action="previous-article"><kbd>↑</kbd> Previous article</button>
</div>
`;
}
